module.exports = __webpack_public_path__ + "img/remainder2.2aaf758a.svg";